"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyData = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("@blueprintjs/core");
var EmptyData = function (props) {
    var text = (props && props.settings && props.settings.text && props.settings.text) ||
        'No data';
    var color = (props &&
        props.settings &&
        props.settings.color &&
        props.settings.color) ||
        'rgba(49, 59, 67, 0.27)';
    var height = (props &&
        props.settings &&
        props.settings.height &&
        props.settings.height) ||
        '100%';
    var backgroundColor = (props &&
        props.settings &&
        props.settings.backgroundColor &&
        props.settings.backgroundColor) ||
        'rgb(245, 245, 245)';
    var iconSize = (props &&
        props.settings &&
        props.settings.iconSize &&
        props.settings.iconSize) ||
        28;
    var textSize = (props &&
        props.settings &&
        props.settings.textSize &&
        props.settings.textSize) ||
        22;
    var icon = (props && props.settings && props.settings.icon && props.settings.icon) ||
        'th';
    var customerIcon = props &&
        props.settings &&
        props.settings.customerIcon &&
        props.settings.customerIcon;
    var renderIcon = customerIcon ? (customerIcon) : (react_1.default.createElement(core_1.Icon, { icon: icon, iconSize: iconSize }));
    return (react_1.default.createElement("div", { style: {
            height: '100%',
            width: '100%',
            position: 'relative',
            minHeight: '15vh'
        }, className: 'empty-container' },
        react_1.default.createElement("div", { style: {
                height: height,
                backgroundColor: backgroundColor,
                color: color,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'absolute',
                width: '100%'
            } },
            react_1.default.createElement("div", { style: { textAlign: 'center' } },
                renderIcon,
                react_1.default.createElement("p", { style: { color: color, fontSize: textSize, fontWeight: 400, width: 100 }, className: "bp3-heading" }, text)))));
};
exports.EmptyData = EmptyData;
